"use client";

import { useState } from "react";

/* Program math: Ranksector is $99/mo and the commission is 25%,
 * so each active referral pays out $24.75 every month. */
const PLAN_PRICE = 99;
const COMMISSION_RATE = 0.25;
const PER_REFERRAL = PLAN_PRICE * COMMISSION_RATE; // 24.75

const MIN_REFS = 1;
const MAX_REFS = 100;

const fmt = (n: number) =>
  n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

export default function EarningsCalculator() {
  const [refs, setRefs] = useState(25);
  const monthly = refs * PER_REFERRAL;
  const annual = monthly * 12;
  const fill = ((refs - MIN_REFS) / (MAX_REFS - MIN_REFS)) * 100;

  return (
    <div className="af-calc-card">
      <div className="af-calc-head">
        <span className="af-calc-title">Earnings calculator</span>
        <span className="af-calc-badge">
          <span className="af-pulse" aria-hidden="true" />
          Lifetime recurring
        </span>
      </div>

      <div className="af-math-row" aria-label="Commission math">
        <div className="af-math-cell">
          <div className="af-math-n">{refs}</div>
          <div className="af-math-l">referrals</div>
        </div>
        <span className="af-math-op" aria-hidden="true">
          &times;
        </span>
        <div className="af-math-cell">
          <div className="af-math-n">$99</div>
          <div className="af-math-l">per month</div>
        </div>
        <span className="af-math-op" aria-hidden="true">
          &times;
        </span>
        <div className="af-math-cell af-math-hl">
          <div className="af-math-n">25%</div>
          <div className="af-math-l">your cut</div>
        </div>
      </div>

      <div className="af-slider-block">
        <div className="af-slider-head">
          <span className="af-slider-label">Active referrals</span>
          <span className="af-slider-value">{refs}</span>
        </div>
        <input
          type="range"
          min={MIN_REFS}
          max={MAX_REFS}
          value={refs}
          onChange={(e) => setRefs(parseInt(e.target.value, 10) || MIN_REFS)}
          className="af-slider"
          aria-label="Active referrals per month"
          style={{ "--af-fill": `${fill}%` } as React.CSSProperties}
        />
        <div className="af-slider-scale" aria-hidden="true">
          <span>1</span>
          <span>25</span>
          <span>50</span>
          <span>75</span>
          <span>100</span>
        </div>
      </div>

      <div className="af-calc-result">
        <div className="af-result-main">
          <div className="af-result-label">
            That&rsquo;s $24.75 per referral, every month they stay.
          </div>
          <div className="af-result-num">
            {fmt(monthly)}
            <span className="af-result-per"> / month</span>
          </div>
        </div>
        <span className="af-result-annual">{fmt(annual)} / year</span>
      </div>

      {refs >= 100 && (
        <p className="af-custom-note">
          Sending 100+ referrals?{" "}
          <a href="mailto:hi@ranksector.com?subject=Custom%20affiliate%20terms">
            Email us about custom terms
          </a>{" "}
          and we&rsquo;ll work something out.
        </p>
      )}
    </div>
  );
}
